export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_retrofit-visit-check/artifacts/80rwhpss_Retrotrack%20Logo%20Full%20Small.png";

export const BRANDMARK_URL =
  "https://customer-assets.emergentagent.com/job_retrofit-visit-check/artifacts/6j8dkfib_Retrotrack%20Brandmark%20Small.png";

export const LOGIN_BG =
  "https://images.pexels.com/photos/8961001/pexels-photo-8961001.jpeg";

// PAS 2035:2023 / TrustMark audit-aligned general checks
export const GENERAL_CHECKS = {
  mid: [
    "Property identity confirmed (front-of-dwelling photo taken)",
    "Approved retrofit design / specification available on site",
    "Works being carried out in accordance with the design (including interface details)",
    "Correct materials on site and stored appropriately",
    "PPE worn and site health & safety observed",
    "Ventilation strategy being maintained during works",
    "Workmanship to an acceptable standard so far",
    "Site left tidy and all rubbish / waste removed",
    "Any non-conformances raised with the installer and recorded",
  ],
  post: [
    "Property identity confirmed (front-of-dwelling photo taken)",
    "All measures complete in accordance with the approved design (including interface details)",
    "Workmanship to an acceptable standard on completion",
    "All certificates, commissioning documents & handover pack collected and provided to resident",
    "Site cleaned, made good and all rubbish / waste removed on completion",
    "All snags / non-conformances closed out",
    "Resident walkthrough / demonstration of measures completed",
    "Sufficient evidence collected to lodge with TrustMark",
  ],
};

export const RISK_PATHS = [
  { v: "A", l: "Path A — lower risk" },
  { v: "B", l: "Path B — medium risk" },
  { v: "C", l: "Path C — higher risk" },
];

export const ROOM_TYPES = [
  "Living Room",
  "Kitchen",
  "Dining Room",
  "Bedroom 1",
  "Bedroom 2",
  "Bedroom 3",
  "Bedroom 4",
  "Bathroom",
  "En-suite",
  "WC / Cloakroom",
  "Utility Room",
  "Hallway / Landing",
  "Study / Office",
  "Conservatory",
  "Other",
];

export const BG_VENT_OPTIONS = [
  "Trickle vents to window",
  "Wall vent / air brick",
  "Door undercut",
  "Passive stack",
  "Not required",
  "Not provided (defect)",
];

export const DAMP_SEVERITY_LEVELS = ["Low", "Medium", "High"];

export const DAMP_SEVERITY = [
  "Surface mould",
  "Condensation",
  "Penetrating damp",
  "Rising damp",
  "Water ingress / leak",
];

// Thorough damp & mould module (Phase 1)
export const DAMP_STATUS = ["Clear", "Damp / mould present", "Not inspected"];
export const DAMP_TYPES = ["Rising damp", "Penetrating damp", "Condensation", "Surface mould", "Water ingress / leak"];
export const MOULD_RATING = [
  "Cat 1 — mould < 0.5 m²",
  "Cat 2 — mould 0.5–3 m²",
  "Cat 3 — mould > 3 m²",
];
export const AFFECTED_AREA = ["< 0.5 m²", "0.5–1 m²", "1–3 m²", "> 3 m²"];

// Standalone Awaab's Law Damp & Mould Report
export const HAZARD_CLASS = [
  { v: "emergency", l: "Emergency — make safe within 24 hours" },
  { v: "significant", l: "Significant — investigate within 10 working days" },
  { v: "other", l: "Other hazard" },
];
export const HHSRS_CATEGORY = ["Category 1 (serious)", "Category 2", "Not assessed"];
export const HAZARD_BAND = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
export const RAG = ["Red", "Amber", "Green"];
export const MOULD_COVERAGE = ["< 0.5 m²", "0.5–1 m²", "1–3 m²", "> 3 m²"];
export const CONSTRUCTION_TYPES = ["Solid brick", "Cavity brick", "Stone", "System build / concrete", "Timber frame", "Other"];
export const RESPONSIBILITY = ["Landlord — property defect", "Tenant — lifestyle / occupancy", "Mixed / contributory", "Undetermined"];

export const MIN_PHOTOS_PER_MEASURE = 5;

export const PROPERTY_TYPES = [
  "Detached",
  "Semi-detached",
  "Mid-terrace",
  "End-terrace",
  "Bungalow",
  "Flat / Maisonette",
  "Other",
];

export const WALL_TYPES = [
  "Cavity wall",
  "Solid brick",
  "Solid stone",
  "Timber frame",
  "System build",
  "Other",
];

export const SCHEMES = [
  "Saffron Housing",
  "Watford",
  "NYCC (North Yorkshire)",
  "Private / Other",
];
